<template>
	<v-card>
		<v-form ref="formActual">
			<v-container>
				<v-row>
					<v-col md="2" class="font-weight-medium">
						Hemodiálisis
					</v-col>
					<v-col md="2">
						<v-radio-group
							hide-details="auto"
							class="ma-0 pa-0 pr-1 pt-1"
							row
							mandatory
							v-model="valor.Hemodialisis"
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col md="4">
						<v-text-field
							:rules="[
								!valor.Hemodialisis ||
									!!valor.TiempoEnTRR ||
									'Campo Requerido'
							]"
							hide-details="auto"
							outlined
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'Tiempo en TRR'"
							v-model="valor.TiempoEnTRR"
							:disabled="!valor.Hemodialisis"
						></v-text-field>
					</v-col>
					<v-col md="4">
						<v-text-field
							:rules="[
								!valor.Hemodialisis ||
									!!valor.SesionesXSemana ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'Sesiones por semana'"
							v-model="valor.SesionesXSemana"
							:disabled="!valor.Hemodialisis"
							outlined
						></v-text-field>
					</v-col>
				</v-row>
				<v-row dense>
					<v-col md="3">
						<v-text-field
							:rules="[
								!valor.Hemodialisis ||
									!!valor.Uf ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'UF'"
							v-model="valor.Uf"
							:disabled="!valor.Hemodialisis"
							outlined
						></v-text-field>
					</v-col>
					<v-col md="3">
						<v-text-field
							:rules="[
								!valor.Hemodialisis ||
									!!valor.Ktv ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'Kt/v'"
							v-model="valor.Ktv"
							:disabled="!valor.Hemodialisis"
							outlined
						></v-text-field>
					</v-col>
					<v-col md="3">
						<v-text-field
							:rules="[
								!valor.Hemodialisis ||
									!!valor.Urr ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'URR'"
							v-model="valor.Urr"
							:disabled="!valor.Hemodialisis"
							outlined
						></v-text-field>
					</v-col>
					<v-col md="3">
						<v-text-field
							:rules="[
								!valor.Hemodialisis ||
									!!valor.Npna ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'nPNA'"
							v-model="valor.Npna"
							:disabled="!valor.Hemodialisis"
							outlined
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="2" class="font-weight-medium">
						Diálisis Peritoneal
					</v-col>
					<v-col md="2">
						<v-radio-group
							hide-details="auto"
							class="ma-0 pa-0 pr-1 pt-1"
							row
							mandatory
							v-model="valor.DialisisPeritoneal"
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col md="2">
						Modalidad
					</v-col>
					<v-col md="2">
						<v-radio-group
							:rules="[
								!valor.DialisisPeritoneal ||
									!!valor.Modalidad ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="ma-0 pa-0 pr-1 pt-1"
							row
							mandatory
							:disabled="!valor.DialisisPeritoneal"
							v-model="valor.Modalidad"
						>
							<v-radio label="DPA" value="dpa"></v-radio>
							<v-radio label="DPCA" value="dpca"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="4">
						<v-text-field
							:rules="[
								!valor.DialisisPeritoneal ||
									!!valor.TiempoDialisis ||
									'Campo Requerido'
							]"
							hide-details="auto"
							outlined
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'Tiempo en TRR'"
							v-model="valor.TiempoDialisis"
							:disabled="!valor.DialisisPeritoneal"
						></v-text-field>
					</v-col>
					<v-col md="4">
						<v-text-field
							outlined
							:rules="[
								!valor.DialisisPeritoneal ||
									!!valor.NoRecambios ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'No. de recambios'"
							v-model="valor.NoRecambios"
							:disabled="!valor.DialisisPeritoneal"
						></v-text-field>
					</v-col>
					<v-col md="4">
						<v-text-field
							outlined
							:rules="[
								!valor.DialisisPeritoneal ||
									!!valor.Glucosa ||
									'Campo Requerido'
							]"
							hide-details="auto"
							class="pa-0 ma-0 pr-1 pt-1"
							:label="'[Glucosa]'"
							v-model="valor.Glucosa"
							:disabled="!valor.DialisisPeritoneal"
						></v-text-field>
					</v-col>
				</v-row>
			</v-container>
		</v-form>
		<v-layout row class="mt-3" v-if="!esVisita">
			<v-flex xs6>
				<v-btn color="primary" @click.prevent="anterior">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" @click.prevent="guardar">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
	</v-card>
</template>
<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos", "esVisita", "validateForm"],
	name: "terapiaReemplazoRenal",
	data() {
		return {
			valor: {
				Hemodialisis: false,
				Tiempo: "",
				Dias: "",
				Uf: "",
				Ktv: "",
				Urr: "",
				Npna: "",
				DialisisPeritoneal: false,
				Modalidad: "",
				TiempoDialisis: "",
				NoRecambios: "",
				Glucosa: ""
			}
		};
	},
	mounted() {},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	methods: {
		anterior() {
			this.$emit("anterior");
		},
		siguiente() {
			this.$emit("siguiente");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarTerapiaRenal(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		}
	},
	watch: {
		datos() {
			if (this.datos) {
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		validateForm() {
			if (this.validateForm) {
				if (!this.$refs.formActual.validate()) {
					this.$emit("valorCambiado", null);
				} else {
					this.$emit("valorCambiado", this.valor);
				}
			}
		}
	}
};
</script>
